<template>
  <div>
    <!-- <div v-if="showLogin === false" class="medical-report-top">
      <div style="width:95%" @click="routeToLoign">查看其他亲友报告</div>
      <img
        :src="require('@assets/report_jump.png')"
        alt=""
        @click="routeToLoign"
      />
    </div> -->
    <!-- <div v-if="showLogin === true" class="medical-report-login">
      <div class="medical-report-login-logo">
        <img :src="require('@assets/report_srm2_logo.png')" alt="" />
      </div>
      <div class="medical-report-login-lable">自助领取，省时省力</div>
      <van-form class="medical-report-login-form" @submit="onSubmit">
        <van-field v-model="name" placeholder="请输入姓名" />
        <van-field
          v-model="telphone"
          type="number"
          placeholder="请输入手机号"
          :rules="[
            {
              required: true,
              pattern: /^1(3|4|5|6|7|8|9)\d{9}$/,
              message: '请填写正确的手机号'
            }
          ]"
        />
        <van-field
          v-model="verifyCode"
          placeholder="请输入图形验证码"
          :rules="[{ required: true, message: '请填写图形验证码' }]"
        >
          <img
            slot="right-icon"
            :src="verifyCodeImage"
            alt=""
            @click="getVerifyCode"
          />
        </van-field>
        <van-field
          v-model="phoneCode"
          placeholder="短信验证码"
          :rules="[{ required: true, message: '请填写短信验证码' }]"
        >
          <span
            v-if="verifyCodeImage"
            slot="right-icon"
            class="user-setting-phone-send-verifycode"
            :style="countDownTime ? 'color: gray;' : 'color: blue'"
            :disabled="countDownTime > 0"
            @click="sendCode"
          >
            {{ countDownTime ? `${countDownTime}s后重新发送` : "发送验证码" }}
          </span>
        </van-field>
        <ph-button
          class="medical-report-login-commit-button"
          title="查询报告"
          native-type="submit"
        />
      </van-form>
    </div> -->
    <div v-if="showList === true">
      <div
        v-for="(item, index) in list"
        :key="index"
        class="medical-report-list"
      >
        <div class="medical-report-list-top">
          <div class="medical-report-list-top-logo">
            <!-- <img :src="require('@assets/report_srm2_small_logo.png')" alt="" /> -->
          </div>
          <div class="medical-report-list-top-title">龙岩人民医院</div>
          <div class="medical-report-list-top-time">{{ item.date }}</div>
        </div>
        <div class="medical-report-list-content">
          <div class="medical-report-list-content-lable">
            体检人：<span>{{ item.patientName }}</span>
          </div>
          <div class="medical-report-list-content-lable">
            体检号：<span>{{ item.reportNo }}</span>
          </div>
          <div class="medical-report-list-content-lable">
            电话：<span>{{ item.phone }}</span>
          </div>
          <div class="medical-report-list-content-lable">
            体检类型：<span>{{ item.reportType }}</span>
          </div>
          <div @click="routeTo(item)" class="medical-report-list-content-btn">
            查看体检报告明细
          </div>
        </div>
      </div>
    </div>
    <ph-empty v-if="!list.length" bgcolor="white" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      telphone: "",
      verifyCode: "",
      name: "",
      phoneCode: "",
      verifyCodeId: "",
      verifyCodeImage: "",
      countDownTime: 0,
      timer: null,
      mesToken: "",
      list: [],
      showLogin: false,
      showList: true,
    };
  },
  created() {
    this.getReportList();
  },
  methods: {
    getReportList() {
      // this.mesToken = localStorage.getItem("mesToken");
      // if (this.mesToken) {
      this.$http
        .post(this.$api.MES_REPORT_LIST, { functionType: "1" })
        .then((res) => {
          this.list = res.map((item) => {
            return {
              ...item,
              date: item.reportDate.split(" ")[0],
            };
          });
        })
        .catch(() => {
          this.list = [];
        });
      // }
      // else {
      //   this.list = [];
      //   this.showList = true;
      //   this.showLogin = false;
      //   // this.getVerifyCode();
      // }
    },
    getVerifyCode() {
      this.$http.post(this.$api.USER_VERIFY_CODE, {}).then((res) => {
        this.verifyCodeId = res.picId;
        this.verifyCodeImage = res.url;
      });
    },
    sendCode() {
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      if (!this.name) {
        this.$toast("请输入您的姓名");
        return;
      }
      this.$http
        .post(this.$api.REST_MES_SENDSMS, {
          picId: this.verifyCodeId,
          picCode: this.verifyCode,
          phone: this.telphone,
          name: this.name,
        })
        .then(() => {
          this.$toast("发送成功");
          this.startCountDown();
        });
    },
    routeTo(item) {
      window.location.href = item.reportUrl;
      // window.location.href =
      //   "/pdf/web/viewer.html?file=" + encodeURIComponent(item.reportUrl);
    },
    onSubmit() {
      if (!this.name) {
        this.$toast("请输入您的姓名");
        return;
      }
      if (!this.telphone) {
        this.$toast("请输入手机号");
        return;
      }
      if (!this.verifyCode) {
        this.$toast("请输入图形验证码");
        return;
      }
      if (!this.phoneCode) {
        this.$toast("请输入验证码");
        return;
      }
      this.list = [];
      this.$http
        .post(this.$api.REST_MES_LOGIN, {
          phone: this.telphone,
          name: this.name,
          smsCode: this.phoneCode,
        })
        .then((res) => {
          localStorage.setItem("mesToken", res);
          this.getReportList();
        });
    },
    routeToLoign() {
      this.showLogin = true;
      this.showList = false;
      this.getVerifyCode();
    },
    startCountDown() {
      clearInterval(this.timer);
      this.timer = null;
      this.countDownTime = 60;
      this.timer = setInterval(() => {
        if (this.countDownTime > 0) {
          this.countDownTime -= 1;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
  },
};
</script>

<style lang="less">
.medical-report-top {
  display: flex;
  align-items: center;
  height: 2.5rem;
  color: white;
  text-align: right;
  background-color: rgb(63, 100, 232);
  img {
    width: 1.5rem;
    height: 1.5rem;
    margin: 0.5rem;
  }
}
.medical-report-list {
  margin: 1rem 1rem 0 1rem;
  border-radius: 0.2rem;
  &-content {
    margin-bottom: 1rem;
    padding-bottom: 1rem;
    color: rgb(153, 153, 153);
    font-weight: bold;
    background-color: rgb(240, 247, 254);
    &-lable {
      padding: 0.5rem 0.5rem 0 1rem;
      span {
        margin-left: 1rem;
        color: black;
        font-weight: normal;
      }
    }
    &-btn {
      margin: 1rem 3rem 0 3rem;
      color: #fff;
      font-weight: normal;
      line-height: 2rem;
      text-align: center;
      background-color: rgb(127, 117, 247);
      border-radius: 4px;
    }
  }
  &-top {
    display: flex;
    height: 2.5rem;
    color: white;
    line-height: 2.5rem;
    background-color: rgb(63, 100, 232);
    &-logo {
      width: 2rem;
      height: 2rem;
      margin: 0.25rem;
      img {
        width: 100%;
        height: 100%;
      }
    }
    &-time {
      margin-right: 0.2rem;
      margin-left: auto;
    }
  }
}
.medical-report-login {
  background-color: white;
  &-lable {
    font-weight: bold;
    font-style: 2rem;
    text-align: center;
  }
  &-logo {
    width: 10rem;
    height: 10rem;
    margin: 2rem auto 1rem auto;
    img {
      width: 100%;
      height: 100%;
    }
  }
  &-form {
    padding: 0.8rem;
    background: white;

    .van-cell {
      padding: 0.6rem 0;
      border-bottom: 1px solid @primary-gray;
      input::-webkit-input-placeholder {
        color: gray;
      }
    }

    .van-cell::after {
      position: relative;
    }

    .van-field__body {
      font-size: 0.94rem;
    }
  }

  &-send-verifycode {
    font-size: 0.8rem;
    line-height: 1.5rem;
  }

  &-commit-button {
    width: 100%;
    margin: 1rem 0 0 0;
    line-height: 2.5rem;
  }

  &-tips {
    margin: 1rem 0.4rem;
    color: red;
    font-size: 0.8rem;
    div {
      color: gray;
    }
  }
}
</style>
